import styled from 'styled-components';
import ReactLink from '@exo/frontend-common-link';
import { breakpoints } from '@exo/frontend-common-theme-utils';
import theme from './CookieBanner.theme';

export const CookieBanner = styled('div')`
  display: flex;
  flex-direction: column;
  padding: ${props => theme(props).cookiePaddingMobile};

  ${breakpoints.greaterThan('medium')`
    padding: ${props => theme(props).cookiePadding};
  `};

  ${breakpoints.greaterThan('large')`
    flex-direction: row;
  `};
`;

export const Title = styled('h2')`
  color: ${props => theme(props).titleColor};
  font: ${props => theme(props).titleFontMobile};
  padding-top: 2rem;

  ${breakpoints.greaterThan('medium')`
    font: ${props => theme(props).titleFont};
  `};
`;

export const Text = styled('p')`
  color: ${props => theme(props).textColor};
  font: ${props => theme(props).textFontMobile};
  line-height: 1.75;
  margin: ${props => theme(props).textMargin};

  ${breakpoints.greaterThan('medium')`
    font: ${props => theme(props).textFont};
  `};
`;

export const Actions = styled('div')`
  display: flex;
  flex-direction: column;
  margin: ${props => theme(props).actionsMarginMobile};
  text-align: center;

  ${breakpoints.greaterThan('large')`
    margin: ${props => theme(props).actionsMargin};
  `};

  & .cookie-btn {
    font: ${props => theme(props).actionFont};
    max-width: ${props => theme(props).buttonMaxWidth};
    width: 100%;
  }

  & .reject-btn {
    margin: ${props => theme(props).actionMargin};
  }
`;

export const Link = styled(ReactLink)`
  color: ${props => theme(props).linkColor};
  font: ${props => theme(props).actionFont};
  margin: ${props => theme(props).linkMarginMobile};
  white-space: nowrap;

  ${breakpoints.greaterThan('large')`
    margin: ${props => theme(props).actionMargin};
  `};
`;
